import * as React from 'react'
import { Analytics } from "@vercel/analytics/react"

// 1. import `ChakraProvider` component
import { ChakraProvider } from '@chakra-ui/react'
import Navbar from './Navbar';
import Speakers from './Speakers';
import BackgroundImage from './BackgroundImage';
import Agenda from './Agenda';
import Logos from './Logos';
import HappyHour from './HappyHour';

function App() {
  // 2. Wrap ChakraProvider at the root of your app
  return (
    <ChakraProvider>
      <Navbar></Navbar>
      <BackgroundImage></BackgroundImage>
      <Speakers></Speakers>
      <Logos></Logos>
      <Agenda></Agenda>
      <HappyHour></HappyHour>
      <Analytics />
    </ChakraProvider>
  )
}
export default App;